(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-buy-box"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrInit === '1') return;
    root.dataset.vyrInit = '1';

    var variants = JSON.parse(root.querySelector('[data-vyr-variants]').textContent);
    var cfg = JSON.parse(root.querySelector('[data-vyr-config]').textContent);
    var idField = root.querySelector('[data-vyr-variant-id]');
    var atc = root.querySelector('[data-vyr-atc]');
    var atcText = root.querySelector('[data-vyr-atc-text]');
    var atcLabel = atcText ? atcText.textContent : '';

    function money(c) {
      var v = (c / 100).toFixed(2);
      return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    function packOf() {
      var el = root.querySelector('input[name="vyr-pack"]:checked');
      return el ? el.value : null;
    }
    function labelFor(pack) {
      var all = root.querySelectorAll('[data-vyr-pack]');
      for (var i = 0; i < all.length; i++) if (all[i].dataset.vyrPack === pack) return all[i];
      return null;
    }
    function sizeOf(label) {
      var s = label && label.querySelector('[data-vyr-sizeselect]');
      return s ? s.value : null;
    }
    function colorOf(label) {
      var c = label && label.querySelector('[data-vyr-colorselect]');
      return c ? c.value : null;
    }
    function find(size, pack, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.size === size && v.pack === pack && (!color || !v.color || v.color === color)) return v;
      }
      return null;
    }

    function paint() {
      root.querySelectorAll('[data-vyr-pack]').forEach(function (label) {
        var v = find(sizeOf(label), label.dataset.vyrPack, colorOf(label));
        if (!v) { label.style.display = 'none'; return; }
        label.style.display = '';
        var price = label.querySelector('[data-vyr-pack-price]');
        var cmp = label.querySelector('[data-vyr-pack-compare]');
        var save = label.querySelector('[data-vyr-pack-save]');
        if (price) price.textContent = money(v.price);
        if (cmp) cmp.textContent = v.compare > v.price ? money(v.compare) : '';
        if (save) save.textContent = v.compare > v.price ? (cfg.saveLabel || '').replace('{amount}', money(v.compare - v.price)) : '';
      });
    }

    function sync() {
      paint();
      var label = labelFor(packOf());
      var v = find(sizeOf(label), packOf(), colorOf(label));
      if (!v) return;
      idField.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? atcLabel : (cfg.soldOut || 'Sold out');
      }
    }

    // les tailles des paliers non sélectionnés ne doivent pas partir au panier
    function toggleProps() {
      root.querySelectorAll('[data-vyr-pack]').forEach(function (label) {
        var on = !!label.querySelector('input[name="vyr-pack"]:checked');
        label.querySelectorAll('[data-vyr-extrasize],[data-vyr-extracolor]').forEach(function (sel) {
          sel.disabled = !on;
        });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'vyr-pack') { sync(); toggleProps(); return; }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-colorselect')) {
        var cv = e.target.value;
        root.querySelectorAll('[data-vyr-colorselect]').forEach(function (c) { c.value = cv; });
        paintSwatches(); sync(); return;
      }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-extracolor')) { paintSwatches(); return; }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-sizeselect')) {
        var val = e.target.value;
        root.querySelectorAll('[data-vyr-sizeselect]').forEach(function (s) { s.value = val; });
        sync();
      }
    });

    var stage = root.querySelector('[data-vyr-stage]');
    var thumbs = root.querySelectorAll('[data-vyr-thumb]');
    function goTo(i) {
      var s = root.querySelector('[data-vyr-slide="' + i + '"]');
      if (s && stage) stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.vyrThumb); }); });
    function activeIndex() {
      var a = root.querySelector('[data-vyr-thumb].is-active');
      return a ? parseInt(a.dataset.vyrThumb, 10) : 0;
    }
    var tp = root.querySelector('[data-vyr-tprev]'), tn = root.querySelector('[data-vyr-tnext]');
    if (tp) tp.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
    if (tn) tn.addEventListener('click', function () { goTo(Math.min(thumbs.length - 1, activeIndex() + 1)); });
    if (stage && thumbs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          thumbs.forEach(function (t) {
            var on = t.dataset.vyrThumb === en.target.dataset.vyrSlide;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      }, { root: stage, threshold: 0.6 });
      root.querySelectorAll('[data-vyr-slide]').forEach(function (s) { io.observe(s); });
    }

    // vignette du coloris dans chaque ligne
    var swatchEl = root.querySelector('[data-vyr-swatches]');
    var swatches = swatchEl ? JSON.parse(swatchEl.textContent) : {};
    function paintSwatches() {
      root.querySelectorAll('.vyr-swatch').forEach(function (w) {
        var sel = w.querySelector('select');
        var thumb = w.querySelector('[data-vyr-swatchthumb]');
        var url = sel && swatches[sel.value];
        if (thumb && url) thumb.style.backgroundImage = 'url("' + url + '")';
      });
    }

    // guide des tailles : modale, plus de scroll dans le vide
    var modal = root.querySelector('[data-vyr-sgmodal]');
    root.querySelectorAll('[data-vyr-sizeguide]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (modal && modal.showModal) { modal.showModal(); return; }
        var t = document.getElementById('vyr-size-guide');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    if (modal) {
      var x = modal.querySelector('[data-vyr-sgclose]');
      if (x) x.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }
    paintSwatches();

    sync();
    toggleProps();
  }
  function boot() { document.querySelectorAll('[data-vyr-buy]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-buybox-cream"]) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrInit === '1') return;
    root.dataset.vyrInit = '1';

    var cfg      = JSON.parse(root.querySelector('[data-vyr-config]').textContent);
    var swatchEl = root.querySelector('[data-vyr-swatches]');
    var swatches = swatchEl ? JSON.parse(swatchEl.textContent) : {};
    var form     = root.querySelector('[data-vyr-form]');
    var atc      = root.querySelector('[data-vyr-atc]');
    var atcText  = root.querySelector('[data-vyr-atc-text]');
    var atcLabel = atcText ? atcText.textContent : '';

    function selectedTier() {
      var i = root.querySelector('input[name="vyr-pack"]:checked');
      if (!i) return null;
      var all = root.querySelectorAll('[data-vyr-pack]');
      for (var k = 0; k < all.length; k++) if (all[k].dataset.vyrPack === i.value) return all[k];
      return null;
    }

    // la pastille de teinte suit le libellé choisi, pas l'id de variante
    function paintSwatches() {
      root.querySelectorAll('.vyr-swatch').forEach(function (w) {
        var sel = w.querySelector('select');
        var thumb = w.querySelector('[data-vyr-swatchthumb]');
        if (!sel || !thumb) return;
        var name = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
        var url = swatches[name];
        if (url) thumb.style.backgroundImage = 'url("' + url + '")';
      });
    }
    root.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-shade')) paintSwatches();
    });

    // Le pack part au panier en N lignes de la variante à l'unité : c'est ce qui donne
    // le détail par teinte dans le panier et la remise visible au checkout.
    if (atc) {
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        var tier = selectedTier();
        if (!tier || (atc && atc.disabled)) return;

        var counts = {};
        tier.querySelectorAll('[data-vyr-shade]').forEach(function (sel) {
          counts[sel.value] = (counts[sel.value] || 0) + 1;
        });
        var items = Object.keys(counts).map(function (id) {
          return { id: Number(id), quantity: counts[id] };
        });
        if (!items.length) return;

        if (atc) atc.disabled = true;
        if (atcText && cfg.adding) atcText.textContent = cfg.adding;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t); });
          if (atc) atc.disabled = false;
          if (atcText) atcText.textContent = atcLabel;
          // le tiroir custom (section vyran-cart-v4) est le panier du site ;
          // /cart n'est qu'un repli si son script n'a pas chargé.
          if (window.vyrCart && window.vyrCart.refresh) return window.vyrCart.refresh(true);
          window.location.href = cfg.cartUrl || '/cart';
        }).catch(function (err) {
          if (atc) atc.disabled = false;
          if (atcText) atcText.textContent = atcLabel;
          console.error('[VYRAN] ajout au panier', err);
        });
      });
    }

    // galerie : vignettes + flèches, inchangé
    var stage = root.querySelector('[data-vyr-stage]');
    var thumbs = root.querySelectorAll('[data-vyr-thumb]');
    function goTo(i) {
      var s = root.querySelector('[data-vyr-slide="' + i + '"]');
      if (s && stage) stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.vyrThumb); }); });
    function activeIndex() {
      var a = root.querySelector('[data-vyr-thumb].is-active');
      return a ? parseInt(a.dataset.vyrThumb, 10) : 0;
    }
    var tp = root.querySelector('[data-vyr-tprev]'), tn = root.querySelector('[data-vyr-tnext]');
    if (tp) tp.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
    if (tn) tn.addEventListener('click', function () { goTo(Math.min(thumbs.length - 1, activeIndex() + 1)); });
    if (stage && thumbs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          thumbs.forEach(function (t) {
            var on = t.dataset.vyrThumb === en.target.dataset.vyrSlide;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      }, { root: stage, threshold: 0.6 });
      root.querySelectorAll('[data-vyr-slide]').forEach(function (s) { io.observe(s); });
    }

    paintSwatches();
  }
  function boot() { document.querySelectorAll('[data-vyr-buy]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-buybox-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrInit === '1') return;
    root.dataset.vyrInit = '1';

    var variants = JSON.parse(root.querySelector('[data-vyr-variants]').textContent);
    var cfg = JSON.parse(root.querySelector('[data-vyr-config]').textContent);
    var idField = root.querySelector('[data-vyr-variant-id]');
    var atc = root.querySelector('[data-vyr-atc]');
    var atcText = root.querySelector('[data-vyr-atc-text]');
    var atcLabel = atcText ? atcText.textContent : '';

    function money(c) {
      var v = (c / 100).toFixed(2);
      return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    function packOf() {
      var el = root.querySelector('input[name="vyr-pack"]:checked');
      return el ? el.value : null;
    }
    function labelFor(pack) {
      var all = root.querySelectorAll('[data-vyr-pack]');
      for (var i = 0; i < all.length; i++) if (all[i].dataset.vyrPack === pack) return all[i];
      return null;
    }
    function sizeOf(label) {
      var s = label && label.querySelector('[data-vyr-sizeselect]');
      return s ? s.value : null;
    }
    function colorOf(label) {
      var c = label && label.querySelector('[data-vyr-colorselect]');
      return c ? c.value : null;
    }
    function find(size, pack, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.size === size && v.pack === pack && (!color || !v.color || v.color === color)) return v;
      }
      return null;
    }

    function paint() {
      root.querySelectorAll('[data-vyr-pack]').forEach(function (label) {
        var v = find(sizeOf(label), label.dataset.vyrPack, colorOf(label));
        if (!v) { label.style.display = 'none'; return; }
        label.style.display = '';
        var price = label.querySelector('[data-vyr-pack-price]');
        var cmp = label.querySelector('[data-vyr-pack-compare]');
        var save = label.querySelector('[data-vyr-pack-save]');
        if (price) price.textContent = money(v.price);
        if (cmp) cmp.textContent = v.compare > v.price ? money(v.compare) : '';
        if (save) save.textContent = v.compare > v.price ? (cfg.saveLabel || '').replace('{amount}', money(v.compare - v.price)) : '';
      });
    }

    function sync() {
      paint();
      var label = labelFor(packOf());
      var v = find(sizeOf(label), packOf(), colorOf(label));
      if (!v) return;
      idField.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? atcLabel : (cfg.soldOut || 'Sold out');
      }
    }

    // les tailles des paliers non sélectionnés ne doivent pas partir au panier
    function toggleProps() {
      root.querySelectorAll('[data-vyr-pack]').forEach(function (label) {
        var on = !!label.querySelector('input[name="vyr-pack"]:checked');
        label.querySelectorAll('[data-vyr-extrasize],[data-vyr-extracolor]').forEach(function (sel) {
          sel.disabled = !on;
        });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'vyr-pack') { sync(); toggleProps(); return; }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-colorselect')) {
        var cv = e.target.value;
        root.querySelectorAll('[data-vyr-colorselect]').forEach(function (c) { c.value = cv; });
        paintSwatches(); sync(); return;
      }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-extracolor')) { paintSwatches(); return; }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-sizeselect')) {
        var val = e.target.value;
        root.querySelectorAll('[data-vyr-sizeselect]').forEach(function (s) { s.value = val; });
        sync();
      }
    });

    var stage = root.querySelector('[data-vyr-stage]');
    var thumbs = root.querySelectorAll('[data-vyr-thumb]');
    function goTo(i) {
      var s = root.querySelector('[data-vyr-slide="' + i + '"]');
      if (s && stage) stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.vyrThumb); }); });
    function activeIndex() {
      var a = root.querySelector('[data-vyr-thumb].is-active');
      return a ? parseInt(a.dataset.vyrThumb, 10) : 0;
    }
    var tp = root.querySelector('[data-vyr-tprev]'), tn = root.querySelector('[data-vyr-tnext]');
    if (tp) tp.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
    if (tn) tn.addEventListener('click', function () { goTo(Math.min(thumbs.length - 1, activeIndex() + 1)); });
    if (stage && thumbs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          thumbs.forEach(function (t) {
            var on = t.dataset.vyrThumb === en.target.dataset.vyrSlide;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      }, { root: stage, threshold: 0.6 });
      root.querySelectorAll('[data-vyr-slide]').forEach(function (s) { io.observe(s); });
    }

    // vignette du coloris dans chaque ligne
    var swatchEl = root.querySelector('[data-vyr-swatches]');
    var swatches = swatchEl ? JSON.parse(swatchEl.textContent) : {};
    function paintSwatches() {
      root.querySelectorAll('.vyr-swatch').forEach(function (w) {
        var sel = w.querySelector('select');
        var thumb = w.querySelector('[data-vyr-swatchthumb]');
        var url = sel && swatches[sel.value];
        if (thumb && url) thumb.style.backgroundImage = 'url("' + url + '")';
      });
    }

    // guide des tailles : modale, plus de scroll dans le vide
    var modal = root.querySelector('[data-vyr-sgmodal]');
    root.querySelectorAll('[data-vyr-sizeguide]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (modal && modal.showModal) { modal.showModal(); return; }
        var t = document.getElementById('vyr-size-guide');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    if (modal) {
      var x = modal.querySelector('[data-vyr-sgclose]');
      if (x) x.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }
    paintSwatches();

    sync();
    toggleProps();
  }
  function boot() { document.querySelectorAll('[data-vyr-buy]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-buybox-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrInit === '1') return;
    root.dataset.vyrInit = '1';

    var variants = JSON.parse(root.querySelector('[data-vyr-variants]').textContent);
    var cfg = JSON.parse(root.querySelector('[data-vyr-config]').textContent);
    var idField = root.querySelector('[data-vyr-variant-id]');
    var atc = root.querySelector('[data-vyr-atc]');
    var atcText = root.querySelector('[data-vyr-atc-text]');
    var atcLabel = atcText ? atcText.textContent : '';

    function money(c) {
      var v = (c / 100).toFixed(2);
      return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
    }
    function packOf() {
      var el = root.querySelector('input[name="vyr-pack"]:checked');
      return el ? el.value : null;
    }
    function labelFor(pack) {
      var all = root.querySelectorAll('[data-vyr-pack]');
      for (var i = 0; i < all.length; i++) if (all[i].dataset.vyrPack === pack) return all[i];
      return null;
    }
    function sizeOf(label) {
      var s = label && label.querySelector('[data-vyr-sizeselect]');
      return s ? s.value : null;
    }
    function colorOf(label) {
      var c = label && label.querySelector('[data-vyr-colorselect]');
      return c ? c.value : null;
    }
    function find(size, pack, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.size === size && v.pack === pack && (!color || !v.color || v.color === color)) return v;
      }
      return null;
    }

    function paint() {
      root.querySelectorAll('[data-vyr-pack]').forEach(function (label) {
        var v = find(sizeOf(label), label.dataset.vyrPack, colorOf(label));
        if (!v) { label.style.display = 'none'; return; }
        label.style.display = '';
        var price = label.querySelector('[data-vyr-pack-price]');
        var cmp = label.querySelector('[data-vyr-pack-compare]');
        var save = label.querySelector('[data-vyr-pack-save]');
        if (price) price.textContent = money(v.price);
        if (cmp) cmp.textContent = v.compare > v.price ? money(v.compare) : '';
        if (save) save.textContent = v.compare > v.price ? (cfg.saveLabel || '').replace('{amount}', money(v.compare - v.price)) : '';
      });
    }

    function sync() {
      paint();
      var label = labelFor(packOf());
      var v = find(sizeOf(label), packOf(), colorOf(label));
      if (!v) return;
      idField.value = v.id;
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? atcLabel : (cfg.soldOut || 'Sold out');
      }
    }

    // les tailles des paliers non sélectionnés ne doivent pas partir au panier
    function toggleProps() {
      root.querySelectorAll('[data-vyr-pack]').forEach(function (label) {
        var on = !!label.querySelector('input[name="vyr-pack"]:checked');
        label.querySelectorAll('[data-vyr-extrasize],[data-vyr-extracolor]').forEach(function (sel) {
          sel.disabled = !on;
        });
      });
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'vyr-pack') { sync(); toggleProps(); return; }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-colorselect')) {
        var cv = e.target.value;
        root.querySelectorAll('[data-vyr-colorselect]').forEach(function (c) { c.value = cv; });
        paintSwatches(); sync(); return;
      }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-extracolor')) { paintSwatches(); return; }
      if (e.target.hasAttribute && e.target.hasAttribute('data-vyr-sizeselect')) {
        var val = e.target.value;
        root.querySelectorAll('[data-vyr-sizeselect]').forEach(function (s) { s.value = val; });
        sync();
      }
    });

    var stage = root.querySelector('[data-vyr-stage]');
    var thumbs = root.querySelectorAll('[data-vyr-thumb]');
    function goTo(i) {
      var s = root.querySelector('[data-vyr-slide="' + i + '"]');
      if (s && stage) stage.scrollTo({ left: s.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.vyrThumb); }); });
    function activeIndex() {
      var a = root.querySelector('[data-vyr-thumb].is-active');
      return a ? parseInt(a.dataset.vyrThumb, 10) : 0;
    }
    var tp = root.querySelector('[data-vyr-tprev]'), tn = root.querySelector('[data-vyr-tnext]');
    if (tp) tp.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
    if (tn) tn.addEventListener('click', function () { goTo(Math.min(thumbs.length - 1, activeIndex() + 1)); });
    if (stage && thumbs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          thumbs.forEach(function (t) {
            var on = t.dataset.vyrThumb === en.target.dataset.vyrSlide;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      }, { root: stage, threshold: 0.6 });
      root.querySelectorAll('[data-vyr-slide]').forEach(function (s) { io.observe(s); });
    }

    // vignette du coloris dans chaque ligne
    var swatchEl = root.querySelector('[data-vyr-swatches]');
    var swatches = swatchEl ? JSON.parse(swatchEl.textContent) : {};
    function paintSwatches() {
      root.querySelectorAll('.vyr-swatch').forEach(function (w) {
        var sel = w.querySelector('select');
        var thumb = w.querySelector('[data-vyr-swatchthumb]');
        var url = sel && swatches[sel.value];
        if (thumb && url) thumb.style.backgroundImage = 'url("' + url + '")';
      });
    }

    // guide des tailles : modale, plus de scroll dans le vide
    var modal = root.querySelector('[data-vyr-sgmodal]');
    root.querySelectorAll('[data-vyr-sizeguide]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (modal && modal.showModal) { modal.showModal(); return; }
        var t = document.getElementById('vyr-size-guide');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    if (modal) {
      var x = modal.querySelector('[data-vyr-sgclose]');
      if (x) x.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }
    paintSwatches();

    sync();
    toggleProps();
  }
  function boot() { document.querySelectorAll('[data-vyr-buy]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-reviewapp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrRaInit === '1') return;
    root.dataset.vyrRaInit = '1';

    root.querySelectorAll('[data-vyr-ramore]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var extra = btn.parentNode.querySelector('.vyr-ra__txt--more');
        if (!extra) return;
        var open = !extra.hidden;
        extra.hidden = open;
        var ell = btn.parentNode.querySelector('[data-vyr-raell]');
        if (ell) ell.style.display = open ? '' : 'none';
        btn.textContent = open ? 'More' : 'Less';
      });
    });

    var strip = root.querySelector('[data-vyr-rastrip]');
    var stripNext = root.querySelector('[data-vyr-rastripnext]');
    if (strip && stripNext) {
      stripNext.addEventListener('click', function () {
        var end = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        strip.scrollLeft = end ? 0 : strip.scrollLeft + 178;
      });
    }

    var show = root.querySelector('[data-vyr-rashow]');
    if (show) {
      show.addEventListener('click', function () {
        var hidden = root.querySelectorAll('.vyr-ra__item.is-hidden');
        for (var i = 0; i < 12 && i < hidden.length; i++) hidden[i].classList.remove('is-hidden');
        if (root.querySelectorAll('.vyr-ra__item.is-hidden').length === 0) show.style.display = 'none';
      });
    }
  }
  function boot() { document.querySelectorAll('.vyr-ra').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.vyrRevInit === '1') return;
    root.dataset.vyrRevInit = '1';
    var rail = root.querySelector('[data-vyr-rail]');
    if (!rail) return;
    var cards = [].slice.call(rail.children);
    var dotsBox = root.querySelector('[data-vyr-dots]');
    var prev = root.querySelector('[data-vyr-prev]');
    var next = root.querySelector('[data-vyr-next]');

    function go(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (c) rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    }
    function current() {
      var best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - rail.offsetLeft - rail.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    if (dotsBox) {
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vyr-rev__dot' + (i === 0 ? ' is-on' : '');
        b.setAttribute('aria-label', 'Review ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(b);
      });
    }
    function paint() {
      var i = current();
      if (dotsBox) [].slice.call(dotsBox.children).forEach(function (d, j) {
        d.classList.toggle('is-on', j === i);
      });
    }
    rail.addEventListener('scroll', function () {
      window.clearTimeout(rail._t);
      rail._t = window.setTimeout(paint, 90);
    });
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
  }
  function boot() { document.querySelectorAll('.vyr-rev').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-trustwall"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrTwInit === '1') return;
    root.dataset.vyrTwInit = '1';
    var rail = root.querySelector('[data-vyr-twrail]');
    if (!rail) return;
    var cards = [].slice.call(rail.children);
    function current() {
      var best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - rail.offsetLeft - rail.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    function go(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (c) rail.scrollTo({ left: c.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    }
    /* une flèche = une page de cartes, comme chez la référence */
    function step() { return window.innerWidth >= 990 ? 3 : 1; }
    var prev = root.querySelector('[data-vyr-twprev]');
    var next = root.querySelector('[data-vyr-twnext]');
    if (prev) prev.addEventListener('click', function () { go(current() - step()); });
    if (next) next.addEventListener('click', function () { go(current() + step()); });
  }
  function boot() { document.querySelectorAll('.vyr-tw').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrUgcInit === '1') return;
    root.dataset.vyrUgcInit = '1';
    root.querySelectorAll('[data-vyr-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var holder = btn.parentNode;
        var v = document.createElement('video');
        v.className = 'vyr-ugc__vid';
        v.poster = btn.querySelector('img') ? btn.querySelector('img').src : '';
        v.src = btn.dataset.vyrVideo;
        v.controls = true;
        v.autoplay = true;
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        holder.replaceChild(v, btn);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }, { once: true });
    });
  }
  function boot() { document.querySelectorAll('.vyr-ugc').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vyran-video-gallery"]) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vyrVgInit === '1') return;
    root.dataset.vyrVgInit = '1';
    var vids = root.querySelectorAll('[data-vyr-vgv]');
    if (!('IntersectionObserver' in window)) {           // repli : on charge tout
      vids.forEach(function (v) {
        var s = v.querySelector('source');
        if (s && !s.src) { s.src = s.dataset.src; v.load(); }
        v.play().catch(function () {});
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target, s = v.querySelector('source');
        if (e.isIntersecting) {
          if (s && !s.src) { s.src = s.dataset.src; v.load(); }
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '150px', threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }
  function boot() { document.querySelectorAll('.vyr-vg').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();
})();
